import React from "react";
import { ErrorMessage } from "formik";

export const InputError = ({ title }: { title: string }) => (
    <ErrorMessage name={title} render={msg => <div style={{ color: 'rgba(173, 18, 20, 0.84)' }}>{msg}</div>} />
)